import { FC } from 'react'
import styled from 'styled-components'
import { useActivityFilterMid } from './ActivityFilterMid.module'
import ActivityFilterSlides from './ActivityFilterSlides'
import JobCategoryField from './JobCategoryField'
import KeywordField from './KeywordField'

interface IFActivityFilterMidProps {
  className?: string
}

const ActivityFilterMid: FC<IFActivityFilterMidProps> = ({ className }) => {
  const { activityTypeIsRecruit } = useActivityFilterMid()

  return (
    <StyledWrapper className={className}>
      <KeywordField />
      {activityTypeIsRecruit && <JobCategoryField />}
      <ActivityFilterSlides />
    </StyledWrapper>
  )
}

export default ActivityFilterMid

const StyledWrapper = styled.div`
  padding: 0 20px;
  > div {
    margin-top: 30px;
  }
`
